import { Input } from '@trackman/web-shared-components';
import { useState } from 'react';

export const VideoLength = ({
  videoLengthHours,
  videoLengthMinutes,
  setVideoLengthHours,
  setVideoLengthMinutes,
}: {
  videoLengthHours: string;
  videoLengthMinutes: string;
  setVideoLengthHours: (value: string) => void;
  setVideoLengthMinutes: (value: string) => void;
}) => {
  return (
    <div className='admin-edit-section'>
      <h2>Recording length*</h2>
      <div className='inputs-container video-length'>
        <Input
          label='Hours'
          value={videoLengthHours ?? ''}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setVideoLengthHours(e.currentTarget.value)}
        />
        <Input
          label='Minutes'
          value={videoLengthMinutes ?? ''}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setVideoLengthMinutes(e.currentTarget.value)}
        />
      </div>
    </div>
  );
};
